import type { IconData } from '@stacksjs/iconify-core'

export const chevronsSquareDownRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm8 10V9a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1H9a1 1 0 0 1 0-2zM9 9V6a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1H6a1 1 0 0 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronsSquareDownRight
